import { GetUsersArgs } from 'types/api/arguments/get-users-args'
import { UsersResp } from 'types/api/response/users-resp'

import { api } from './api'

export const getUsers = ({ perPage, searchText, page, order, itemId }: GetUsersArgs) =>
  api.get<UsersResp>('/users', {
    params: {
      page,
      order,
      per_page: perPage,
      search_text: searchText,
      order_by_buyer_for_item: itemId,
    },
  })
